module.exports = __webpack_public_path__ + "img/ji-4.1397c002.png";